/**
 * Der `AbortError`, den Supabases Navigator-LockManager-Hülle wirft, wenn sie
 * `lock:sb-…-auth-token` nicht binnen `lockAcquireTimeout` (10 s) bekommt.
 *
 * Er trägt keinen verwertbaren Stack (`@supabase/auth-js/lib/locks.js:108`)
 * und keinen Grund. Als Sentry-Exception gemeldet begräbt er echte Fehler, und
 * unbehandelt reißt er im Dev-Modus das Fehler-Overlay über das ganze Fenster.
 *
 * Auf `name` und Wortlaut geprüft, nicht auf `instanceof DOMException`: Im
 * Renderer kommt er als DOMException, in Tests und über Bibliotheksgrenzen
 * hinweg auch als schlichtes Error-Objekt.
 */
export function isAuthLockAbort(reason: unknown): boolean {
  if (typeof reason !== 'object' || reason === null) return false
  const { name, message } = reason as { name?: unknown; message?: unknown }
  return name === 'AbortError' && message === 'signal is aborted without reason'
}
